import clsx from 'clsx'
import Link from 'next/link'
import React from 'react'
import { InternalLink } from '../../const/Links'
import { Translation } from '../../contexts/TranslationContext'
import SvgWarning from '../../svg/icons/Warning'
import { useAuth } from '../../user/UserContext'
import style from './NotSpecifiedAlert.module.sass'

type NotSpecifiedAlertProps = {
	color?: 'grey' | 'olive'
	notSigned?: boolean
}

export const NotSpecifiedAlert = React.memo(function NotSpecifiedAlert(props: NotSpecifiedAlertProps) {
	const auth = useAuth()
	const signedButNoRegistration = auth.status === 'signedIn' // alert not visible to not signed users
	return (
		<div
			className={clsx(
				style.wrapper,
				props.color === 'olive' && style.wrapperOlive,
				props.color === 'grey' && style.wrapperGrey,
			)}
		>
			<span className={style.iconWrapper}>
				<SvgWarning />
			</span>
			{props.notSigned ? (
				<span>
					{signedButNoRegistration ? (
						<Translation tr="alert.finishRegistration" />
					) : (
						<>
							<Translation tr="notSpecifiedAlert.paragraph.login.first" />
							<br /> <Translation tr="notSpecifiedAlert.paragraph.login.second" />{' '}
							<Link href={InternalLink.Login} title="Registrujte se">
								<span className={style.specifyButtonText}>
									<Translation tr="notSpecifiedAlert.paragraph.login.third" />
								</span>
							</Link>
						</>
					)}
				</span>
			) : (
				<span>
					<Translation tr="notSpecifiedAlert.paragraph.specifyDog.first" />
					<br />
					<Link href={InternalLink.Wizard} title="Registrace">
						<span className={style.specifyButtonText}>
							<Translation tr="notSpecifiedAlert.paragraph.specifyDog.second" />
						</span>
					</Link>
				</span>
			)}
		</div>
	)
})
